export default function Logo({ tone = 'dark' }) {
  return (
    <span className={`logo logo--${tone}`}>
      <span className="logo__mark" aria-hidden="true">
        <svg viewBox="0 0 40 40" width="38" height="38">
          <circle cx="20" cy="20" r="19" fill="currentColor" />
          <path
            d="M11 13.5c3-1 6-.7 9 1 3-1.7 6-2 9-1v13c-3-1-6-.7-9 1-3-1.7-6-2-9-1z"
            fill="none"
            stroke="#fff"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path d="M20 14.5v13" stroke="#fff" strokeWidth="1.8" />
          <path
            d="M15 20.5l1.8 1.8 3.2-3.4"
            fill="none"
            stroke="#fff"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            transform="translate(7.5 0)"
          />
        </svg>
      </span>
      <span className="logo__text">
        <span className="logo__title">
          Books <em>Experts</em>
        </span>
        <small>Accounting software help</small>
      </span>
    </span>
  );
}
